/**
 * Contact Form Validation
 * Validates required fields (name, email, message) before form submission
 */

document.addEventListener("DOMContentLoaded", function () {
  const forms = document.querySelectorAll(".contact-form__form");

  forms.forEach((form) => {
    // Type check to ensure form is HTMLFormElement
    if (!(form instanceof HTMLFormElement)) return;

    form.addEventListener(
      "submit",
      function (e) {
        // Get all required inputs using form elements
        const nameInput = /** @type {HTMLInputElement} */ (
          form.elements.namedItem("contact[name]")
        );
        const emailInput = /** @type {HTMLInputElement} */ (
          form.elements.namedItem("contact[email]")
        );
        const bodyInput = /** @type {HTMLTextAreaElement} */ (
          form.elements.namedItem("contact[body]")
        );

        // Remove existing error classes and reset error messages
        form.querySelectorAll(".contact-form__field").forEach((field) => {
          field.classList.remove("has-error");
          const errorMsg = field.querySelector(".contact-form__error-message");
          if (errorMsg) {
            errorMsg.textContent = "*This is a compulsory field";
          }
        });

        let isValid = true;

        // Validate name
        if (!nameInput || !nameInput.value.trim()) {
          if (nameInput) {
            const errorField = nameInput.closest(".contact-form__field");
            if (errorField) {
              errorField.classList.add("has-error");
              const errorMsg = errorField.querySelector(
                ".contact-form__error-message"
              );
              if (errorMsg) {
                errorMsg.textContent = "*This is a compulsory field";
              }
            }
          }
          isValid = false;
        }

        // Validate email
        if (!emailInput || !emailInput.value.trim()) {
          if (emailInput) {
            const errorField = emailInput.closest(".contact-form__field");
            if (errorField) {
              errorField.classList.add("has-error");
              const errorMsg = errorField.querySelector(
                ".contact-form__error-message"
              );
              if (errorMsg) {
                errorMsg.textContent = "*This is a compulsory field";
              }
            }
          }
          isValid = false;
        } else {
          // Validate email format
          const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailPattern.test(emailInput.value.trim())) {
            const errorField = emailInput.closest(".contact-form__field");
            if (errorField) {
              errorField.classList.add("has-error");
              const errorMsg = errorField.querySelector(
                ".contact-form__error-message"
              );
              if (errorMsg) {
                errorMsg.textContent = "*Please enter a valid email address";
              }
            }
            isValid = false;
          }
        }

        // Validate body
        if (!bodyInput || !bodyInput.value.trim()) {
          if (bodyInput) {
            const errorField = bodyInput.closest(".contact-form__field");
            if (errorField) {
              errorField.classList.add("has-error");
              const errorMsg = errorField.querySelector(
                ".contact-form__error-message"
              );
              if (errorMsg) {
                errorMsg.textContent = "Please enter a valid email address";
              }
            }
          }
          isValid = false;
        }

        // Prevent submission if invalid
        if (!isValid) {
          e.preventDefault();
          e.stopImmediatePropagation();
          return false;
        }

        return true;
      },
      true
    );
  });
});
